import { Box, Typography } from '@mui/material';
import DragDrop from '../components/DemoPanels/DragDrop'
import Suggestions from '../components/DemoPanels/Suggestions'
import Customize from '../components/DemoPanels/Customize'

export default function DemoPanels(props) {
    var gridMargin = props.gridMargin
    return (
        <Box sx={{ justifyContent: 'flex-start', textAlign: 'left', paddingTop: "36px", margin: gridMargin }}>
            {/* <Typography variant="h5" sx={{ textAling: "left" }}>What you can do with good blocks</Typography> */}
            <DragDrop gridMargin={gridMargin} />
            <Suggestions gridMargin={gridMargin} />
            <Customize gridMargin={gridMargin} />
        </Box>
    )
}